import Api from './ApiService'

export default {
    get(keyword, pageNumber, pageSize, order) {
        return Api().get(`notification_variable?keyword=${keyword}&pageNumber=${pageNumber}&pageSize=${pageSize}&orderColumn=${order.column}&orderSort=${order.sort}`);
    },
    getOne(id) {
        return Api().get(`notification_variable/${id}`);
    },
    create(data) {
        return Api().post(`notification_variable`, data);
    },
    update(data) {
        return Api().put(`notification_variable/${data.id}`, data);
    }
}